(function() {
    // Parallax Hero Banner
    function parallaxEffect(banner, speedFactor) {
        if (banner) {
            var latestScrollY = 0;
            var ticking = false;

            function isInViewport() {
                var rect = banner.getBoundingClientRect();
                return (
                    rect.bottom > 0 &&
                    rect.top < window.innerHeight
                );
            }

            function updateParallax() {
                if (isInViewport()) {
                    var offset = latestScrollY * speedFactor;
                    banner.style.backgroundPosition = 'center ' + (-offset) + 'px';
                }
                ticking = false;
            }

            function onScroll() {
                latestScrollY = window.scrollY;
                if (!ticking) {
                    window.requestAnimationFrame(updateParallax);
                    ticking = true;
                }
            }
            window.addEventListener('scroll', onScroll, { passive: true });
            // Also update on resize in case of viewport changes
            window.addEventListener('resize', onScroll, { passive: true });

            // Initial call to set background position on load
            latestScrollY = window.scrollY;
            updateParallax();
        }
    }

    var heroBanner = document.querySelector('.hero-banner');
    parallaxEffect(heroBanner, 0.2);

    var footerBanner = document.querySelector('.footer-banner');
    parallaxEffect(footerBanner, 0.2);

    // Utility: Entrance Animation with data-delay support
    function applyEntranceAnimation(className = 'animate-on-scroll', animationClass = 'in-view') {
        var elements = document.querySelectorAll('.' + className);

        function checkInView() {
            var windowHeight = window.innerHeight;
            elements.forEach(function(el) {
                var rect = el.getBoundingClientRect();
                if (rect.top < windowHeight - 40 && !el.classList.contains(animationClass)) {
                    var delay = parseInt(el.getAttribute('data-delay'), 10) || 0;
                    setTimeout(function() {
                        el.classList.add(animationClass);
                    }, delay);
                }
            });
        }

        // Initial check
        checkInView();

        // Listen for scroll and resize
        window.addEventListener('scroll', checkInView, { passive: true });
        window.addEventListener('resize', checkInView);
    }

    // Apply to elements with .animate-on-scroll
    applyEntranceAnimation();

    // Apply to product images
    applyEntranceAnimation('product-animate', 'in-view');

})();